import { scaleImage } from "../../../store/customizerSlice";

export const handlePointerDown = (
  e, canvasRef, images, setSelectedImageIndex, setDragStart, setIsDragging, CANVAS_WIDTH, CANVAS_HEIGHT
) => {
  e.preventDefault();

  const rect = canvasRef.current.getBoundingClientRect();
  const scaleX = CANVAS_WIDTH / rect.width;
  const scaleY = CANVAS_HEIGHT / rect.height;
  const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  const clientY = e.touches ? e.touches[0].clientY : e.clientY;
  const mouseX = (clientX - rect.left) * scaleX;
  const mouseY = (clientY - rect.top) * scaleY;

  for (let i = images.length - 1; i >= 0; i--) {
    const img = images[i];
    const scaledWidth = img.width * img.scale;
    const scaledHeight = img.height * img.scale;
    const offsetX = img.x + (img.width - scaledWidth) / 2;
    const offsetY = img.y + (img.height - scaledHeight) / 2;

    if (mouseX >= offsetX && mouseX <= offsetX + scaledWidth && mouseY >= offsetY && mouseY <= offsetY + scaledHeight) {
      setSelectedImageIndex(i);
      setDragStart({ x: (mouseX - img.x) / img.scale, y: (mouseY - img.y) / img.scale });
      setIsDragging(true);
      return;
    }
  }
};


export const handlePointerMove = (
  e, isDragging, selectedImageIndex, canvasRef, images, dragStart, dispatch, moveImage, CANVAS_WIDTH, CANVAS_HEIGHT, touchesRef
) => {
  if (selectedImageIndex === null) return;

  const rect = canvasRef.current.getBoundingClientRect();
  const scaleX = CANVAS_WIDTH / rect.width;
  const scaleY = CANVAS_HEIGHT / rect.height;

  if (e.touches && e.touches.length === 2) {
    e.preventDefault();
  
    const dx = e.touches[0].clientX - e.touches[1].clientX;
    const dy = e.touches[0].clientY - e.touches[1].clientY;
    const currentDistance = Math.sqrt(dx * dx + dy * dy);
    const selectedImage = images[selectedImageIndex];
  
    if (!touchesRef.current.initialDistance) {
      touchesRef.current.initialDistance = currentDistance;
      touchesRef.current.initialScale = selectedImage.scale;
      console.log('Initialized pinch:', touchesRef.current.initialDistance, touchesRef.current.initialScale);
    }

    const initialDistance = touchesRef.current.initialDistance;
    const initialScale = touchesRef.current.initialScale;
    const scaleFactor = currentDistance / initialDistance;
    let newScale = initialScale * scaleFactor;
    newScale = Math.max(0.5, Math.min(selectedImage.maxScale, newScale));
  
    dispatch(scaleImage({ id: selectedImage.id, scale: newScale }));
    return;
  }

  if (isDragging && (!e.touches || e.touches.length === 1)) {
    e.preventDefault();

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const mouseX = (clientX - rect.left) * scaleX;
    const mouseY = (clientY - rect.top) * scaleY;
    const selectedImage = images[selectedImageIndex];

    dispatch(
      moveImage({
        id: selectedImage.id,
        x: mouseX - dragStart.x * selectedImage.scale,
        y: mouseY - dragStart.y * selectedImage.scale,
      })
    );
  }
};


export const handlePointerUp = (setDragStart, setIsDragging, touchesRef) => {
  setDragStart(null);
  setIsDragging(false);
  touchesRef.current.initialDistance = null;
  touchesRef.current.initialScale = null;
};
